/*=========================================================================================
  File Name: moduleNotifyMutations.js
  Description: Notify Module Mutations
==========================================================================================*/


export default {

    // API
    // CREATE_DEVICE(state, data) {
    //   state.devices.push(data)
    // },
    // UPDATE_DEVICE(state, data) {
    //   Object.assign(state.device, data)
    //   const index = state.devices.findIndex((t) => t.did == data.did)
    //   Object.assign(state.devices[index], data);
    //   console.log(state.devices);
    // },
    // UPDATE_DEVICE_ENABLE(state, data) {
    //   state.device.enable = data
    // },
    // DELETE_DEVICE(state, data) {
    //   const index = state.devices.findIndex((t) => t.did == data.did)
    //   state.devices.splice(index, 1);
    // },
    // DELETE_DEVICES(state, data) {
    //   // data -> [{did:...}, {did:...}]
    //   data.forEach((data_value) => {
    //     state.devices.forEach((devices_value, index) => {
    //       if (data_value.did === devices_value.did) {
    //         state.devices.splice(index, 1);
    //         return false;
    //       }
    //     })
    //   })
    // },
    // DELETE_DEVICE_LOG(state, data) {
    //   // data -> [{lid:...}, {lid:...}]
    //   data.forEach((data_value) => {
    //     state.log.forEach((log_value, index) => {
    //       if (data_value.lid === log_value.lid) {
    //         state.log.splice(index, 1);
    //         return false;
    //       }
    //     })
    //   })
    // },
    // ENABLE_DEVICES(state, data) {
    //   // data -> [{did:...}, {did:...}]
    //   data.forEach((data_value) => {
    //     state.devices.forEach((devices_value, index) => {
    //       if (data_value.did === devices_value.did) {
    //         state.devices[index].enable = 1;
    //         return false;
    //       }
    //     })
    //   })
    //   // state.device = Object.assign([], state.device)
    //   // console.log('ENABLE_DEVICES', state.devices);
    // },
    // DISABLE_DEVICES(state, data) {
    //   // data -> [{did:...}, {did:...}]
    //   data.forEach((data_value) => {
    //     state.devices.forEach((devices_value, index) => {
    //       if (data_value.did === devices_value.did) {
    //         state.devices[index].enable = 0;
    //         return false;
    //       }
    //     })
    //   })
    //   // Object.assign(state.device, state.device)
    //   // console.log('DISABLE_DEVICES', state.devices);
    // },
    SET_NOTIFY(state, data) {
      state.notify = data
    },
    // SET_NOTIFIES(state, data) {
    //   state.devices = data
    // },
    // SET_DEVICE_LOG(state, data) {
    //   state.log = data
    // },
}
